import Img2 from "../images/download/googleapp.svg";
import { useTranslation } from 'react-i18next';

function Download() {
  const { t } = useTranslation();

  return (
    <>
      <section className="download-section">
        <div className="container">
          <div className="download-text">
            <h2>{t('download.title')}</h2>
            <p>{t('download.description')}</p>
            <div className="download-text__btns">
              <a href="https://play.google.com/store/apps/details?id=com.exvrtise.exvrtise&hl=tr" target="_blank" rel="noopener noreferrer">
                <img alt="download_img" src={Img2} style={{ width: "200px", height: "auto" }} />
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Download;
